import { parse } from 'content-disposition-header';

import { saveBinaryContent, saveContent } from '@paragon/client-tools';

import { ParagonFetchResult } from './paragonFetch';

export class FileResponse {}

export class EmailResponse extends FileResponse {}

export class NoFileContentResponse extends FileResponse {}

export abstract class DownloadableFileResponse extends FileResponse {
  abstract download(fallbackFileName?: string): void;
  abstract downloadWithName(newFileName: string): void;
}

export class BlobFileResponse extends DownloadableFileResponse {
  blob: Blob;
  fileName?: string;

  constructor(source: ParagonFetchResult) {
    super();

    const unparsedDisposition = source.headers.get('content-disposition');
    if (unparsedDisposition != null) {
      const contentDisposition = parse(unparsedDisposition);
      if (contentDisposition.parameters.filename != null) {
        this.fileName = contentDisposition.parameters.filename;
      }
    }
    this.blob = source.response as Blob;
  }

  download(fallbackFileName = 'unknown') {
    saveBinaryContent(this.fileName || fallbackFileName, this.blob);
  }

  downloadWithName(newFileName: string) {
    saveBinaryContent(newFileName, this.blob);
  }
}

export class UrlFileResponse extends DownloadableFileResponse {
  url: URL;

  constructor(source: ParagonFetchResult) {
    super();

    try {
      this.url = new URL(JSON.parse(source.response as string));
    } catch {
      throw new Error('Unable to find returned file.');
    }
  }

  get fileName() {
    const path = this.url.pathname;

    return path.substring(path.lastIndexOf('/') + 1);
  }

  download(fallbackFileName = 'unknown'): void {
    saveContent(this.fileName || fallbackFileName, this.url.href, true);
  }

  downloadWithName(newFileName: string): void {
    saveContent(newFileName, this.url.href, true);
  }
}
